import React, { type ReactElement } from 'react';

import { View } from 'react-native';

import { AutocompleteItem } from './AutocompleteItem';

import type { AutocompleteType } from './types';
import { SuggestionList } from './SuggestionList';
import { useTheme } from 'styled-components/native';


type AutocompleteProps<T> = {
  children: ReactElement;
  data: AutocompleteType<T>[];
  onSelect: (suggestion: AutocompleteType<T>) => void;
  visible?: boolean;
  highlight?: string;
};

export const Autocomplete = <T,>({
  children,
  data,
  onSelect,
  highlight,
  visible = false,
}: AutocompleteProps<T>) => {
  const hasSuggestion = data.length > 0;
  const { isMobile } = useTheme();

  return (
    <View className="z-10">
      <View>{children}</View>
      {visible && data.length > 0 && (
        <View style={{ marginTop: isMobile ? -25 : -29 }} >
          {hasSuggestion && (
            <SuggestionList data={data} onSelect={onSelect} highlight={highlight} />
          )}
        </View>
      )}
    </View>
  );
};